/**
 * 日志管理：查看所有写操作，按日志回滚
 */
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>日志管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-input size="small" v-model="formInline.roomNo" placeholder="房号" clearable style="width: 130px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.operationType" placeholder="操作类型" clearable style="width: 130px">
          <el-option v-for="(label, key) in typeLabels" :key="key" :label="label" :value="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.source" placeholder="来源" clearable style="width: 110px">
          <el-option v-for="(label, key) in sourceLabels" :key="key" :label="label" :value="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.result" placeholder="结果" clearable style="width: 100px">
          <el-option label="成功" value="SUCCESS"></el-option>
          <el-option label="失败" value="FAILED"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.rollbackStatus" placeholder="回滚状态" clearable style="width: 110px">
          <el-option label="未回滚" value="NONE"></el-option>
          <el-option label="已回滚" value="ROLLED_BACK"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker size="small" v-model="dateRange" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" style="width: 240px"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>

    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border style="width: 100%;">
      <el-table-column label="操作时间" width="150">
        <template slot-scope="scope">{{ scope.row.createTime | formatTime }}</template>
      </el-table-column>
      <el-table-column label="类型" width="90">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.operationType === 'ROLLBACK' ? 'warning' : ''">{{ typeLabels[scope.row.operationType] || scope.row.operationType }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="roomNo" label="房号" width="100"></el-table-column>
      <el-table-column label="内容" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.summary || scope.row.errorMessage }}</template>
      </el-table-column>
      <el-table-column label="业务日期" width="100">
        <template slot-scope="scope">{{ scope.row.businessDate | formatDay }}</template>
      </el-table-column>
      <el-table-column label="来源" width="80">
        <template slot-scope="scope">{{ sourceLabels[scope.row.source] || scope.row.source }}</template>
      </el-table-column>
      <el-table-column prop="operatorName" label="操作人" width="90"></el-table-column>
      <el-table-column label="结果" width="70">
        <template slot-scope="scope">
          <span :style="{ color: scope.row.result === 'SUCCESS' ? '#67C23A' : '#F56C6C' }">{{ scope.row.result === 'SUCCESS' ? '成功' : '失败' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="回滚" width="130">
        <template slot-scope="scope">
          <span v-if="scope.row.rollbackStatus === 'ROLLED_BACK'" style="color: #E6A23C">已回滚 {{ scope.row.rolledBackTime | formatTime }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="130" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="openDetail(scope.row)">详情</el-button>
          <el-button v-if="$canManage() && rollbackable(scope.row)" size="mini" type="danger" @click="openDetail(scope.row, true)">回滚</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <el-dialog :title="detailTitle" :visible.sync="detailVisible" width="70%">
      <div v-loading="detailLoading">
        <template v-if="detail">
          <p><b>{{ typeLabels[detail.log.operationType] || detail.log.operationType }}</b> {{ detail.log.summary }}</p>
          <p v-if="detail.log.errorMessage" style="color: #F56C6C">失败原因：{{ detail.log.errorMessage }}</p>
          <div v-for="(change, index) in detail.changes" :key="index" class="change-block">
            <div class="change-title">
              {{ tableLabels[change.table] || change.table }}（编号 {{ change.key }}）
              <el-tag size="mini" :type="actionTag[change.action]">{{ actionLabels[change.action] }}</el-tag>
            </div>
            <el-table size="mini" :data="change.fields" border>
              <el-table-column label="字段" width="180">
                <template slot-scope="scope">{{ columnLabels[scope.row.column] || scope.row.column }}</template>
              </el-table-column>
              <el-table-column label="操作前">
                <template slot-scope="scope">{{ scope.row.before === null ? '（空）' : scope.row.before }}</template>
              </el-table-column>
              <el-table-column label="操作后">
                <template slot-scope="scope">{{ scope.row.after === null ? '（空）' : scope.row.after }}</template>
              </el-table-column>
            </el-table>
          </div>
          <p v-if="!detail.changes.length" style="color: #999">没有数据变动</p>
          <el-alert v-if="detail.log.result === 'SUCCESS' && detail.log.operationType !== 'ROLLBACK'"
            :type="detail.canRollback ? 'warning' : 'info'" :closable="false" show-icon style="margin-top: 12px"
            :title="detail.canRollback ? '回滚后，上面每一行都会恢复成「操作前」的数据（新增的记录会被删除）' : ('不能回滚：' + detail.rollbackBlockedReason)">
          </el-alert>
        </template>
      </div>
      <div slot="footer">
        <el-button size="small" @click="detailVisible = false">关闭</el-button>
        <el-button v-if="$canManage() && detail && detail.canRollback" size="small" type="danger" :loading="rollingBack" @click="doRollback">确认回滚</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import { operationLogPage, operationLogDetail, operationLogRollback } from '../../api/operationLog'

const pad = n => ('0' + n).slice(-2)

export default {
  data() {
    return {
      loading: false,
      listData: [],
      dateRange: null,
      formInline: { current: 1, size: 20, roomNo: '', operationType: '', source: '', result: '', rollbackStatus: '' },
      pageparm: { currentPage: 1, pageSize: 20, total: 0 },
      detailVisible: false,
      detailLoading: false,
      detail: null,
      detailTitle: '日志详情',
      rollingBack: false,
      typeLabels: {
        CHECK_IN: '入住', RENEW: '续费', CHECK_OUT: '退房', TRANSFER: '换房',
        REVENUE_ADD: '新增收入', REVENUE_EDIT: '修改收入', REVENUE_DELETE: '删除收入',
        EXPENSE_ADD: '新增支出', EXPENSE_EDIT: '修改支出', EXPENSE_DELETE: '删除支出',
        ROOM_ADD: '新增房间', ROOM_EDIT: '修改房间', ROOM_DELETE: '删除房间',
        DIVIDEND: '分红', ROLLBACK: '回滚'
      },
      sourceLabels: { WEB: '电脑端', APP: 'App', DAILY_REPORT: '照片记账', SYSTEM: '系统' },
      tableLabels: {
        business_room: '房间', business_revenue_flow: '收入流水', business_expenditure_flow: '支出流水',
        business_room_residence_record: '居住记录', business_dividend_record: '分红记录'
      },
      actionLabels: { INSERT: '新增', UPDATE: '修改', DELETE: '删除' },
      actionTag: { INSERT: 'success', UPDATE: '', DELETE: 'danger' },
      columnLabels: {
        room_no: '房号', room_status: '房间状态(1空 2住 0异常)', paid_in_price: '实收租金', deposit: '押金',
        check_in_time: '入住时间', check_out_time: '到期时间', check_in_batch_id: '入住批次',
        tenant_name: '租客', tenant_phone: '租客电话', tenant_id_card: '身份证', guide_price: '指导价',
        trans_id: '流水号', trans_type: '类型(1新住 2续费)', revenue_date: '收款日期', room_cost: '租金',
        deposit_cost: '押金', network_cost: '网费', sanitation_cost: '卫生费', water_cost: '水费',
        electricity_cost: '电费', other_cost: '其他', total_cost: '合计', period_validity: '时长(月)',
        expenditure_amount: '支出金额', describe: '说明', occurrence_time: '发生时间', notes: '备注', type: '类型'
      }
    }
  },
  filters: {
    formatTime(value) {
      if (!value) return ''
      const d = new Date(value)
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    formatDay(value) {
      if (!value) return ''
      const d = new Date(value)
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    }
  },
  created() {
    this.getdata()
  },
  methods: {
    rollbackable(row) {
      return row.result === 'SUCCESS' && row.rollbackStatus === 'NONE' && row.operationType !== 'ROLLBACK'
    },
    search() {
      this.formInline.current = 1
      this.getdata()
    },
    getdata() {
      const params = Object.assign({}, this.formInline)
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0]
        const end = new Date(this.dateRange[1])
        end.setDate(end.getDate() + 1)
        params.endTime = end
      }
      this.loading = true
      operationLogPage(params).then(res => {
        this.loading = false
        if (res.code !== '200') return this.$message({ type: 'info', message: res.message })
        this.listData = res.data.content
        this.pageparm.currentPage = this.formInline.current
        this.pageparm.pageSize = this.formInline.size
        this.pageparm.total = res.data.total
      }).catch(() => {
        this.loading = false
        this.$message.error('日志加载失败，请稍后再试！')
      })
    },
    callFather(parm) {
      this.formInline.current = parm.currentPage
      this.formInline.size = parm.pageSize
      this.getdata()
    },
    openDetail(row, forRollback) {
      this.detail = null
      this.detailTitle = forRollback ? '回滚确认' : '日志详情'
      this.detailVisible = true
      this.detailLoading = true
      operationLogDetail(row.logId).then(res => {
        this.detailLoading = false
        if (res.code !== '200') return this.$message({ type: 'info', message: res.message })
        this.detail = res.data
      }).catch(() => {
        this.detailLoading = false
        this.$message.error('详情加载失败，请稍后再试！')
      })
    },
    doRollback() {
      const log = this.detail.log
      this.$confirm(`确定回滚「${log.roomNo || ''} ${log.summary || ''}」吗？数据会恢复到操作之前。`, '确认回滚', {
        confirmButtonText: '回滚', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        this.rollingBack = true
        operationLogRollback(log.logId).then(res => {
          this.rollingBack = false
          if (res.code !== '200') return this.$message({ type: 'error', message: res.message })
          this.$message({ type: 'success', message: res.data.dailyReportItemReset ? '已回滚，照片记账中对应明细已改回待入账' : '已回滚' })
          this.detailVisible = false
          this.getdata()
        }).catch(() => {
          this.rollingBack = false
          this.$message.error('回滚失败，请稍后再试！')
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.change-block {
  margin-top: 12px;
}
.change-title {
  font-weight: bold;
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/OperationLog.vue